export default __webpack_public_path__ + "static/media/grayInstagram.36d4f901.svg";